// Core
import React from 'react';

// Libraries
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

// Hooks
import { useBreakpoint } from '../../../../../../hooks/useBreakpoint';

// Plugins
import {
  DEVICE_COMMUNICATION_THRESHOLD,
  isEquipmentRunning,
} from '../../../../../../plugins/crusher';
import { CAVITY_LEVEL_RANGE } from '../../../../../../plugins/thresholds';

// Components
import {
  Paragraph,
  ParagraphSize,
  ParagraphWeight,
} from '../../../../../../layout/elements/Paragraph';
import { Thermometer } from '../../../../../../layout/elements/Thermometer';

// View
import {
  CavityLevelModuleContainer,
  ThermometerContainer,
  TitleContainer,
} from './CavityLevel.style';
import { CavityLevelProps } from './CavityLevel.types';

function CavityLevel({
  className,
  unitData,
  edgeStatus,
  testId,
}: CavityLevelProps): JSX.Element {
  // Dependencies
  const { t } = useTranslation();
  const { isXs } = useBreakpoint();

  return (
    <CavityLevelModuleContainer
      data-testid={testId}
      className={className}
    >
      <TitleContainer data-testid={testId ? `${testId}-title-container` : undefined}>
        <Paragraph
          testId={testId ? `${testId}-title` : undefined}
          weight={ParagraphWeight.bold}
          size={isXs ? ParagraphSize.sm : ParagraphSize.md}
        >
          {t('view.crusher.cavityLevel')}
        </Paragraph>
      </TitleContainer>
      <ThermometerContainer>
        <Thermometer
          className="thermometer"
          testId="cavity-level-thermometer"
          minValue={
            _.isNil(unitData?.cavityLevel)
              ? null
              : CAVITY_LEVEL_RANGE.minValue
          }
          maxValue={
            _.isNil(unitData?.cavityLevel)
              ? null
              : CAVITY_LEVEL_RANGE.maxValue
          }
          value={unitData?.cavityLevel}
          unit="%"
          title={`${t('view.crusher.cavityLevel')}`}
          running={
            isEquipmentRunning(
              edgeStatus,
              unitData?.timestamp,
              DEVICE_COMMUNICATION_THRESHOLD,
            )
          }
        />
      </ThermometerContainer>
    </CavityLevelModuleContainer>
  );
}

export { CavityLevel };
